import { h, Component } from 'preact';
import {JavaScriptIcon, ReactIcon, PreactIcon, ReduxIcon, FirebaseIcon, NodeIcon, ExpressIcon, GithubIcon, HerokuIcon, CssIcon, HtmlIcon} from './../Icons'

export default class ArtScene extends Component {
  render() {
    return (
      <section class="Content border">
        <div class="Container">
          <div class="Product">
            <div class="info">
              <div class="Title">
                <span class="text">Tokyo Art Scene, 2017</span>
              </div>
              <p>
                A feed showing the latest art exhibitions around Tokyo.
              </p>
              <span style={{ width:'100%' }}>
								<JavaScriptIcon />
								<PreactIcon />
								<ReduxIcon />
								<NodeIcon />
								<FirebaseIcon />
								<HtmlIcon />
								<CssIcon />
							</span>
              {false && <a href="https://art.samcor.in" class="Button">View App</a>}
              {false && <a href="https://github.com/samcorin/tokyo-art-scene" class="Button">Source Code</a>}
            </div>
            <div class="Image shadow border">
              <img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/tokyo-art-scene.png?alt=media&token=873bc101-9189-416c-8ada-6e19c1ce394e" style={{ border: 'none', boxShadow: 'none', height: '360px', width: 'auto' }} alt="Tokyo Art Scene" />
            </div>
          </div>
        </div>
      </section>
		);
	}
}



// WEBPACK FOOTER //
// ./components/artscene/index.js